import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';

import { Tax } from '../business-entities/tax.model';
import { TaxDetailsDataService } from '../data-services/tax-details-data.service';

@Injectable({ providedIn: 'root' })
export class TaxDetailsService {
    constructor(
        private TaxDetailsDataService: TaxDetailsDataService
    ) { }

    async getTaxPercentages(dealerId: string): Promise<Tax[]> {
        let returnValue: Tax[] = [];
        await this.TaxDetailsDataService.getTaxPercentages(dealerId)
            .then((result) => {
                returnValue = result.responseObject;
            });
        return returnValue;
    }

    updatetaxPercentages(taxPercentages: Tax[]): Promise<GenericResponse<any>> {
        return this.TaxDetailsDataService.updatetaxPercentages(taxPercentages);
    }
}